// sidebarData.js
export const getSidebarData = (permissions, generalSettings, taxonomy) => {
  const allItems = [
    {
      title: 'Dashboard',
      path: '/dashboard',
      iconPath: 'media/svg/icons/Sidebar/dashboard.svg',
      subItems: [],
      permission: permissions?.list_dashboard === 1,
    },
    {
      title: 'User Management',
      path: '/user-management',
      iconPath: 'media/svg/icons/Sidebar/user-management.svg',
      subItems: [
        {
          name: 'Admin Users',
          path: '/user-management/admin',
          permission: permissions?.list_admin_users === 1,
        },
        {
          name: 'Front-End Users',
          path: '/user-management/front-end-users',
          permission: permissions?.list_frontend_users === 1,
        },
        {
          name: 'Role Management',
          path: '/user-management/role-management',
          permission: permissions?.list_role_management === 1,
        },
        {
          name: 'Accreditation Users',
          path: '/user-management/accreditation',
          permission: permissions?.list_accreditation_users === 1,
        },
        {
          name: 'CF-3 Questionnaire',
          path: '/user-management/cf3-questionnaire',
          permission: permissions?.list_cf3_questionnaire === 1,
        },
        {
          name: 'Issuer Verification',
          path: '/user-management/issuer-verification',
          permission: permissions?.list_issuer_verification === 1,
        },
      ],
      permission: true, // Show parent if any child has permission
    },
    {
      title: `${taxonomy?.projectSingular || 'Project'} Management`,
      path: '/campaign',
      iconPath: 'media/svg/icons/Sidebar/project-management.svg',
      subItems: [
        {
          name: taxonomy?.projectPlural || 'Projects',
          path: '/campaign/campaigns',
          permission: permissions?.list_projects === 1,
        },
        {
          name: 'Categories',
          path: '/campaign/categories',
          permission: permissions?.list_categories === 1,
        },
      ],
      permission: true, // Show parent if any child has permission
    },
    {
      title: 'API Management',
      path: '/api-management',
      iconPath: 'media/svg/icons/Sidebar/api-management.svg',
      subItems: [
        {
          name: 'Payment Gateway',
          path: '/api-management/payment-gateway',
          permission: permissions?.list_payment_gateways === 1,
        },
        {
          name: 'KYC Settings',
          path: '/api-management/kyc-settings',
          permission: permissions?.list_kyc_settings === 1,
        },
        {
          name: 'Social Setup',
          path: '/api-management/social-signup',
          permission: permissions?.list_social_signup === 1,
        },
        {
          name: 'reCaptcha',
          path: '/api-management/recaptcha',
          permission: permissions?.list_recaptcha === 1,
        },
        {
          name: 'Google Map',
          path: '/api-management/google-map',
          permission: permissions?.list_google_map === 1,
        },
        {
          name: 'Newsletter Settings',
          path: '/api-management/newsletter',
          permission: permissions?.list_newsletter_settings === 1,
        },
      ],
      permission: true,
    },
    {
      title: 'Transactions',
      path: '/transaction',
      iconPath: 'media/svg/icons/Sidebar/transections.svg',
      subItems: [],
      permission: permissions?.list_transactions === 1,
    },
    {
      title: 'AI Assistant Prompts',
      path: '/ai-assistant-prompts',
      iconPath: 'media/svg/icons/Sidebar/ai-prompt.svg',
      subItems: [],
      permission:
        permissions?.list_ai_assistant_prompts === 1 &&
        generalSettings?.AIAssintant === 'YES',
    },
    {
      title: 'Wallet',
      path: '/wallet',
      iconPath: 'media/svg/icons/Sidebar/wallet.svg',
      subItems: [
        {
          name: 'Wallet Transactions',
          path: '/wallet/wallet-transactions',
          permission: permissions?.list_wallet_transactions === 1,
        },
        {
          name: 'Top-up Requests',
          path: '/wallet/topup-requests',
          permission: permissions?.list_topup_requests === 1,
        },
        {
          name: 'Withdraw Requests',
          path: '/wallet/withdraw-requests',
          permission: permissions?.list_withdraw_requests === 1,
        },
      ],
      permission:
        generalSettings?.walletModule === 'yes' &&
        permissions?.list_wallet_transactions === 1,
    },
    {
      title: 'Content Pages',
      path: '/content-page',
      iconPath: 'media/svg/icons/Sidebar/content-pages.svg',
      subItems: [
        {
          name: 'Pages',
          path: '/content-page/pages',
          permission: permissions?.list_pages === 1,
        },
        {
          name: 'Investor Contracts',
          path: '/content-page/investor-contracts',
          permission: permissions?.list_investor_contracts === 1,
        },
        {
          name: 'Menu',
          path: '/content-page/menu',
          permission: permissions?.list_menu === 1,
        },
        // Campaign FAQs menu is hidden. The page itself still exists at
        // /content-page/faqs.
        /* {
          name: 'FAQs',
          path: '/content-page/faqs',
          permission: permissions?.list_faqs === 1,
        }, */
        {
          name: 'FAQs',
          path: '/content-page/front-end-faqs',
          permission: permissions?.list_front_end_faqs === 1,
        },
      ],
      permission: true,
    },
    {
      title: 'Manage Options',
      path: '/manage-options',
      iconPath: 'media/svg/icons/Sidebar/manage-options.svg',
      subItems: [
        {
          name: 'Deal Types',
          path: '/manage-options/deal-type',
          permission: permissions?.list_deal_type === 1,
        },
        // Company Industry is no longer selectable anywhere in the campaign
        // flow (the Company Info dropdown was removed), so the menu is hidden.
        // The page itself still exists at /manage-options/company-industry.
        /* {
          name: 'Company Industry',
          path: '/manage-options/company-industry',
          permission: permissions?.list_company_industry === 1,
        }, */
        // Team Member Type is only used by the real-estate wizard's Team
        // Members section; the site runs equity projects only, so the menu is
        // hidden. The page still exists at /manage-options/team-member-type.
        /* {
          name: 'Team Member Type',
          path: '/manage-options/team-member-type',
          permission: permissions?.list_team_member_type === 1,
        }, */
        // Investor Type only feeds the Lead Investors dropdown in the
        // real-estate wizard's Fundraising Details step (not the account types
        // Individual / Company / …, which are fixed). The site runs equity
        // projects only, so the menu is hidden. The page still exists at
        // /manage-options/investor-type.
        /* {
          name: 'Investor Type',
          path: '/manage-options/investor-type',
          permission: permissions?.list_investor_type === 1,
        }, */
        // Business Type is retired from the admin on client request (menu and
        // route). The existing rows still drive the Licensed Business dropdown
        // on issuer signup and the entity-type mapping.
        /* {
          name: 'Business Type',
          path: '/manage-options/business-type',
          permission: permissions?.list_business_type === 1,
        }, */
        // Project/Campaign Stage only feeds the Project Stage dropdown in the
        // real-estate wizard's Fundraising Details step. The site runs equity
        // projects only, so the menu (and its route) is retired.
        /* {
          name: `${taxonomy?.projectSingular || 'Campaign'} Stage`,
          path: '/manage-options/campaign-stage',
          permission: permissions?.list_campaign_stage === 1,
        }, */
        // Investing Round only feeds the Investing Round dropdown in the
        // real-estate wizard's Fundraising Details step. The site runs equity
        // projects only, so the menu (and its route) is retired.
        /* {
          name: 'Investing Round',
          path: '/manage-options/investing-round',
          permission: permissions?.list_investing_round === 1,
        }, */
      ],
      permission: true,
    },
    {
      title: 'Miscellaneous',
      path: '/miscellaneous',
      iconPath: 'media/svg/icons/Sidebar/miscellaneous.svg',
      subItems: [
        {
          name: 'Countries',
          path: '/miscellaneous/countries',
          permission: permissions?.list_countries === 1,
        },
        {
          name: 'Currency',
          path: '/miscellaneous/currency',
          permission: permissions?.list_currency === 1,
        },
        {
          name: 'Cron Jobs',
          path: '/miscellaneous/cron-jobs',
          permission: permissions?.list_cron_jobs === 1,
        },
        {
          name: 'Language',
          path: '/miscellaneous/language',
          permission: permissions?.list_language === 1,
        },
        {
          name: 'Sliders',
          path: '/miscellaneous/sliders',
          permission: permissions?.list_sliders === 1,
        },
      ],
      permission: true,
    },
    {
      title: 'Secondary Market',
      path: '/secondary-market',
      iconPath: 'media/svg/icons/Sidebar/secondary-Market.svg',
      subItems: [
        {
          name: 'Seller',
          path: '/secondary-market/seller',
          permission: permissions?.list_seller === 1,
        },
        {
          name: 'Buyer',
          path: '/secondary-market/buyer',
          permission: permissions?.list_buyer === 1,
        },
        /* {
          name: "Settings",
          path: "/secondary-market/settings",
          permission: permissions?.view_secondary_market_settings === 1,
        }, */
      ],
      permission: generalSettings?.enableSecondaryMarket === 'YES',
    },
    {
      title: 'Settings',
      path: '/settings',
      iconPath: 'media/svg/icons/Sidebar/settings.svg',
      subItems: [
        {
          name: 'General',
          path: '/settings/general',
          permission: permissions?.view_general_settings === 1,
        },
        {
          name: `${taxonomy?.projectSingular || 'Project'} Settings`,
          path: '/settings/settings-campaign',
          permission: permissions?.view_campaign_settings === 1,
        },
        {
          name: 'Date and Time',
          path: '/settings/date-time',
          permission: permissions?.view_date_time_settings === 1,
        },
        {
          name: 'Meta',
          path: '/settings/meta',
          permission: permissions?.view_meta_settings === 1,
        },
        {
          name: 'Amount',
          path: '/settings/amount',
          permission: permissions?.view_amount_settings === 1,
        },
        {
          name: 'Email',
          path: '/settings/email-templates',
          permission: permissions?.list_email_templates === 1,
        },
      ],
      permission: true,
    },
    {
      title: 'Revenue Settings',
      path: '/revenue-settings',
      iconPath: 'media/svg/icons/Sidebar/revenue-settings.svg',
      subItems:
        generalSettings?.paymentMethod !== 'crypto-payment'
          ? [
              {
                name: 'Investor Fees',
                path: '/revenue-settings/investor-fees',
                permission: permissions?.view_investor_fees === 1,
              },
              {
                name: 'Sponsor Fees',
                path: '/revenue-settings/sponsor-fees',
                permission: permissions?.view_sponsor_fees === 1,
              },
              {
                name: 'Secondary Market',
                path: '/revenue-settings/secondary-market-fees',
                permission: permissions?.view_secondary_market_settings === 1,
              },
              {
                name: 'Transactions',
                path: '/revenue-settings/transactions',
                permission: permissions?.view_revenue_transactions === 1,
              },
            ]
          : [
              {
                name: 'Revenue Fees',
                path: '/revenue-settings/sponsor-fees',
                permission: permissions?.view_sponsor_fees === 1,
              },
            ],
      permission: true,
    },
    {
      title: 'Withdraw Earnings',
      path: '/withdraw-earnings',
      iconPath: 'media/svg/icons/Sidebar/withdraw-earnings.svg',
      subItems: [],
      permission:
        generalSettings?.paymentMethod === 'crypto-payment' &&
        permissions?.view_withdraw_earnings === 1,
    },
    {
      title: 'Spam Settings',
      path: '/spam-settings/spammer',
      iconPath: 'media/svg/icons/Sidebar/spam-settings.svg',
      subItems: [],
      permission: permissions?.list_spam_settings === 1,
    },
    {
      title: 'Contact Enquiry',
      path: '/contact-list',
      iconPath: 'media/svg/icons/Sidebar/contact-enquiry.svg',
      subItems: [],
      permission: permissions?.list_contact_enquiry === 1,
    },
    {
      title: 'Newsletters',
      path: '/newsletter',
      iconPath: 'media/svg/icons/Sidebar/newsletters.svg',
      subItems: [],
      permission: permissions?.list_newsletters === 1,
    },
    {
      title: 'Maintenance Mode',
      path: '/maintenance-mode',
      iconPath: 'media/svg/icons/Sidebar/maintenance-mode.svg',
      subItems: [],
      permission: permissions?.view_maintenance_mode === 1,
    },
    {
      title: 'Support',
      path: '/support',
      iconPath: 'media/svg/icons/Sidebar/support.svg',
      subItems: [
        {
          name: 'Create Request',
          path: '/support/create-request',
          permission: permissions?.create_support_request === 1,
        },
        {
          name: 'View Request',
          path: '/support/view-requests',
          permission: permissions?.list_support_requests === 1,
        },
      ],
      permission: true,
    },
  ];

  // Filter items based on permissions
  return allItems
    .filter((item) => item.permission)
    .map((item) => ({
      ...item,
      subItems: item.subItems.filter((sub) => sub.permission !== false),
    }))
    .filter((item) => item.subItems.length > 0 || item.subItems.length === 0);
};
